// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ComposerContract = contract({
  name: "Composer",
  description: "THE PRIMITIVE for any text composition surface — Slack / Discord /\nTeams chat input, AI chat / copilot prompt box, comment thread input,\nGitHub / Linear / Jira comment box, Reddit / Twitter reply box,\nNotion / Linear document body, email composer, post body, anywhere\na user types text and submits.\n\nCONCRETE TEST — if you find yourself writing a `<textarea>` (or\n`<Input>` styled tall) with a row of `<Bold>` / `<Italic>` /\n`<Paperclip>` / `<Send>` buttons below or beside it, STOP. That is\n`<Composer>`. Use it.\n\nCommon shapes:\n  Chat input with formatting + attachments + send\n    → <Composer formats={[\"bold\",\"italic\",\"code\"]} toolbar attachments />\n  AI prompt box with paperclip + send\n    → <AIChatComposer />  (preset wrapping Composer)\n  Comment / reply input\n    → <ComposerReply triggers={[{char:\"@\", items: people}]} />\n  Document body editor\n    → <Composer toolbar formats={[...]} bare />\n\nBuilt on Lexical for rich text, mentions, slash commands. The\n`attachments` prop wires image paste + paperclip + chip preview row\nwith object URL lifecycle handled internally — don't roll that\nplumbing yourself. The `triggers` prop wires @mentions and /slash\ncommands with a typeahead popover. The `formats` array picks which\ntoolbar buttons render when `toolbar` is on.\n\nShares the lib/demo step vocabulary with <Code> so scripted\ntyping/format/mention demos animate in the same rhythm as your\nterminal demos.",
  import: "@gradeui/ui",
  composesWith: ["AIChatComposer (preset wrapping this with paperclip + send + attachments)","ComposerReply (preset for comment threads)","AIChat (uses AIChatComposer internally)","Card (host above for reply boxes)","Avatar (in leftActions slot for \"your\" avatar next to the input)"],
  styleDefaults: {"ComposerToolbar":"flex flex-wrap items-center gap-0.5","AttachmentChips":"absolute -top-1.5 -right-1.5 h-5 w-5 rounded-full","ComposerInner":"w-full"},
  props: {
  "placeholder": {
      schema: z.string().optional(),
      design: "content",
  },
  "initialText": {
      schema: z.string().optional(),
      design: "content",
      description: "plain text content to seed on mount",
  },
  "initialJson": {
      schema: z.string().optional(),
      design: "content",
      description: "Lexical state JSON (from a previous onSubmit round-trip)",
  },
  "formats": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "available formats (defaults to bold/italic/underline/strikethrough/code/h1/h2/blockquote/ul/ol); pass false for plain text only",
  },
  "toolbar": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "show the formatting toolbar above the editor; default false",
  },
  "triggers": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "mention/slash configs, eg. `[{ char: \"@\", items: people }, { char: \"/\", items: commands }]`",
  },
  "attachments": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "enable image paste + paperclip when true/object; default off",
  },
  "onSubmit": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "isLoading": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "disables editor, swaps default Send for Stop",
  },
  "onStop": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "maxLength": {
      schema: z.number().optional(),
      design: "knob",
  },
  "autoFocus": {
      schema: z.boolean().optional(),
      design: "plumbing",
  },
  "submitOnEnter": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "default true (Shift-Enter still inserts newline)",
  },
  "leftActions": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "override the default paperclip",
  },
  "rightActions": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "override the default Send/Stop",
  },
  "hideSend": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "hide the default Send without replacing it",
  },
  "steps": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "scripted demo sequence",
  },
  "trigger": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "\"mount\" | \"inView\" | \"manual\"; default \"mount\"",
  },
  "play": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "for trigger=\"manual\"",
  },
  "speed": {
      schema: z.unknown().optional(),
      design: "plumbing",
      description: "\"slow\" | \"normal\" | \"fast\"; default \"normal\"",
  },
  "loop": {
      schema: z.boolean().optional(),
      design: "knob",
  },
  "loopDelay": {
      schema: z.number().optional(),
      design: "knob",
      description: "ms between loop iterations, default 2000",
  },
  "readOnly": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "disables editing AND focusability; programmatic playback still works; use for marketing demos so the script doesn't steal focus",
  },
  "bare": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "strip the card chrome",
  },
  "className": {
      schema: z.string().optional(),
      design: "plumbing",
  },
  },
});
